import { Component } from 'react';

class QuestionDropdown extends Component {
  constructor() {
    super();
    this.state = {
      questionId: null,
      open: false,
    };
    this.onQuestionApply = this.onQuestionApply.bind(this);
    this.toggleDisplay = this.toggleDisplay.bind(this);
    this.hideDisplay = this.hideDisplay.bind(this);
  }

  toggleDisplay() {
    this.setState({ open: this.state.open ? false : true });
  }

  hideDisplay() {
    this.setState({ open: false });
  }

  onQuestionApply(questionId) {
    this.setState({ questionId, open: false });
    window.DateRangeQueryString.setQuestion(questionId);
    this.props.onApplyCallback();
  }

  questionLabels(klass) {
    return {
      FcrQuestion: 'First Contact Resolution',
      FCRQuestion: 'First Contact Resolution',
      NpsQuestion: 'NPS',
      NPSQuestion: 'NPS',
      ScalarQuestion: 'Scale',
    }[klass];
  }

  render() {
    const questions = this.props.questions
      .concat()
      .sort((a, b) =>
        a['created_at'] > b['created_at']
          ? -1
          : b['created_at'] > a['created_at']
          ? 1
          : 0,
      );

    return (
      <div
        className="widget-header question-dropdown"
        onClick={this.toggleDisplay}
        onBlur={this.hideDisplay}
        data-open={this.state.open}
      >
        <div className="flex align-center justify-space-between">
          <div className="title">{this.props.title}</div>
          <i className="dropdown-arrow fa fa-sort-down" />
          <div className="summary-count">{this.props.summaryCount}</div>
        </div>
        <div className="doc-count">{this.props.docCount}</div>
        <p className="subtitle" data-notranslate>
          {this.props.subtitle}
        </p>

        <div className="dropdown-items">
          {questions.map((question, iter) => {
            return (
              <div
                className="dropdown-item"
                onClick={() => this.onQuestionApply(question.id)}
                data-selected={this.props.filters.questionId === question.id}
                key={iter}
              >
                <div className="dropdown-item-top">
                  <div className="question-title" data-notranslate>
                    {this.questionLabels(question.klass)}
                  </div>
                  {question.responses > 0 && (
                    <div className="question-responses">
                      {question.responses} responses
                    </div>
                  )}
                </div>
                <div className="dropdown-item-text">
                  {question.question_text}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

export default QuestionDropdown;
